<template>
  <div id="app-flipchart" class="selectDisable">
    <FlipChart />
  </div>
</template>

<script>
import FlipChart from './components/FlipChart.vue'

export default {
  name: 'App',
  components: {
    FlipChart
  }
}
</script>

<style>


#app-flipchart {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-style: unset !important;
  font-weight: unset !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.selectDisable {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

</style>
